import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInfosController.php
* @route '/api/dossier/update-infos/{dossier}'
*/
const UpdateDossierInfosController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierInfosController.url(args, options),
    method: 'put',
})

UpdateDossierInfosController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-infos/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInfosController.php
* @route '/api/dossier/update-infos/{dossier}'
*/
UpdateDossierInfosController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierInfosController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierInfosController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierInfosController.php
* @route '/api/dossier/update-infos/{dossier}'
*/
UpdateDossierInfosController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierInfosController.url(args, options),
    method: 'put',
})

export default UpdateDossierInfosController